<template>
  <v-data-table
    :loading="loading"
    :headers="headersToShow"
    :items="entities"
    :rows-per-page-items="[10, 20, 30, 50, 100]"
    :pagination.sync="paginationModel"
    :total-items="paginationModel.totalItems"
  >
    <template slot="items" slot-scope="props">
      <template v-for="col of headersToShow">
        <td :class="getTdClass(col)" :key="col.value">
          <template v-if="!Array.isArray(props.item[col.value])">
            <template v-if="col.value == 'actions'">
              <v-btn small flat icon color="grey" class="pa-0 ma-0" @click="showItem(props.item)">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" class="pa-0 ma-0" color="grey" flat small icon>
                  <v-icon small>mdi-dots-horizontal</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-if="props.item.F_BAJA" @click="altaTrabajador(props.item)">
                    <v-list-tile-title>
                      <v-icon color="primary">mdi-check</v-icon>
                      {{ $t('Dar de alta') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile v-if="!props.item.F_BAJA" @click="bajaTrabajador(props.item)">
                    <v-list-tile-title>
                      <v-icon color="error">mdi-cancel</v-icon>
                      {{ $t('Dar de baja') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="modificaContrato(props.item)">
                    <v-list-tile-title>
                      <v-icon color="grey">mdi-account-edit</v-icon>
                      {{ $t('Modificar contrato') }}
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="otrasAcciones(props.item)">
                    <v-list-tile-title>
                      <v-icon color="secondary">mdi-dots-horizontal</v-icon>
                      {{ $t('Otra petición') }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </template>
            <template v-else>
              {{ props.item[col.value] }}
            </template>
          </template>
          <template v-if="Array.isArray(props.item[col.value])">
            <template v-for="ob of props.item[col.value]">
              {{ ob }} &nbsp;
            </template>
          </template>
        </td>
      </template>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">{{ $t('Reset') }}</v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    entities: {
      type: Array,
      default() {
        return [];
      },
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    activeOrInactive: {
      type: String,
      default: 'active',
    },
    hideFields: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {
          descending: true,
          page: 1,
          rowsPerPage: 10, // -1 for All",
          sortBy: '',
          totalItems: 0,
        };
      },
    },
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Cod. Empresa', value: 'CODEMPRE' },
        {
          text: 'Empresa',
          align: 'left',
          value: 'company_name',
          sortable: false,
        },

        { text: 'NIF', value: 'NIF' },
        { text: 'Apellidos, Nombre', value: 'fullname' },
        { text: 'Puesto', value: 'PUESTO' },
        // { text: 'Teléfono', value: 'TELEF1' },
        // { text: 'Bruto', value: 'BRUTO' },
        { text: 'F. inicio', value: 'F_ANTIG' },
        { text: 'F. alta', value: 'F_ALTA' },
        { text: 'F. fin', value: 'F_BAJA' },
        { text: '', value: 'actions', align: 'right', sortable: false },
      ],
    };
  },

  computed: {
    headersToShow() {
      return this.headers.filter(item => {
        if (item.value === 'CODEMPRE' && !this.adminView) {
          return false;
        }
        if (item.value === 'company_name' && !this.adminView) {
          return false;
        }
        if (item.value === 'F_BAJA' && this.activeOrInactive === 'active') {
          return false;
        }
        if (item.value === 'F_ALTA' && this.activeOrInactive === 'active') {
          return false;
        }
        if (item.value === 'EMAIL' && this.activeOrInactive !== 'active') {
          return false;
        }

        return true;
      });
    },

    paginationModel: {
      get: function() {
        return this.pagination;
      },
      set: function(value) {
        this.$emit('update:pagination', value);
      },
    },
  },

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    getTdClass(col) {
      if (col.value === 'actions') {
        return 'text-xs-right pr-0';
      }

      return 'text-xs-left';
    },
    initialize() {},

    altaTrabajador(worker) {
      this.$emit('alta-trabajador-clicked', worker);
    },
    bajaTrabajador(worker) {
      this.$emit('baja-trabajador-clicked', worker);
    },
    modificaContrato(worker) {
      this.$emit('modifica-contrato-clicked', worker);
    },
    otrasAcciones(worker) {
      this.$emit('otras-acciones-clicked', worker);
    },
    showItem(worker) {
      this.$emit('show-item-clicked', worker);
    },
  },
};
</script>

<style></style>
